
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Home from "./components/Home";
import NavBar from "./components/NavBar";
import Portfolio from "./components/Portfolio";
import Prices from "./components/Prices";
import SocialLinks from "./components/SocialLinks";

function App() {
  return (
    <div>
      <NavBar />
      <Home />
      <Portfolio />
      <Prices />
      <Contact />
      <Footer />
      <SocialLinks />
    </div>
  );
}

export default App;
